import { getSingleImgInfo } from '@/api/design'

const mergeSKU = {
  state: {
    productId: [],
    SKUsId: '',
    imgCheck: [],
    imgList: [],
    configList: [],
    productInfo: {},
    productColors: [],
    productSizes: []
  },
  mutations: {
    SET_PRODUCT_ID(state, data) {
      state.productId = data
    },
    SET_SKU_ID(state, data) {
      state.SKUsId = data
    },
    SET_IMG_CHECK(state, data) {
      state.imgCheck = data
    },
    SET_IMG_LIST(state, data) {
      state.imgList = data
    },
    SET_PRODUCT_INFO(state, data) {
      state.productInfo = data
    },
    SET_CONFIG_LIST(state, data) {
      state.configList = data
    },
    UPDATE_CONFIG_LIST(state, data) {
      state.configList.splice(data.index, 1, data.data)
    },
    SET_PRODUCT_COLORS(state, data) {
      state.productColors = data
    },
    SET_PRODUCT_SIZES(state, data) {
      state.productSizes = data
    }
  },
  actions: {
    GetSingleProductInfo({ commit }, id) {
      return new Promise((resolve, reject) => {
        getSingleImgInfo(id).then(res => {
          // console.log(res)
          commit('SET_PRODUCT_INFO', res.data)
          commit('SET_PRODUCT_COLORS', res.data.colors)
          commit('SET_PRODUCT_SIZES', res.data.sizes)
          resolve()
        })
      })
    }
  }
}

export default mergeSKU
